module.exports = __webpack_public_path__ + "img/offline.da38be5c.png";